module.exports = __webpack_public_path__ + "static/media/3.6143a2f5.jpeg";